import React, { useState } from 'react'
import ResetPassJson from "./newPassword.json";
import leftarrow from "../../../assets/images/left-arrow.svg";
import { useHistory } from "react-router-dom";
import eyeiconunfold from "../../../assets/images/eyeiconunfold.svg";
import eyeIcon from "../../../assets/images/eyeicon.svg";
import { Trans, useTranslation } from "react-i18next";
import styles from './newPassword.module.css';
import { Footer } from '../../common/footer/footer';
import { ToastContainer } from 'react-toastify';
const ChangePaawordJsx = (props) => {
  const { t } = useTranslation();
  const history = useHistory();
  const [showPassword, setShowPassword] = useState({});

  const toggleShowPassword = (fieldName) => {
    setShowPassword(prevState => ({
      ...prevState,
      [fieldName]: !prevState[fieldName]
    }));
  };
  let {
    formData,
    onInputChangeHandler,
    onTouchHandler,
    formSubmitButtonDisable,
    formError,
    formSubmitHandler,
    termAndCondition,
    handleChange
  } = props;
  const flowType = localStorage.getItem("flowType");
  return (
    <>
      <section className="mainloginscreen">
        
        <div className="container">
        <div className={`${styles.mainloginscreeninner}`}>
        <div className={`${styles.leftsightbackdetails} d-flex`}>
        <div className="d-flex plaindetailsleft align-items-center justify-content-center">
                <div className="back_btn" onClick={() => history.goBack()}><img src={leftarrow} alt={'icon'} /></div>
                                  <h1>{t("NEWPASSWORD.TITLE")}</h1>
                </div>
              </div>
            </div>



        
           
            <div className={`${styles.formsection}`}>
              <div className={`${styles.institutelogintext}`}>
                <div className="forgetpassinner">
                  {
                    localStorage.getItem('flowName') === 'login' ?
                      <>
                        <h2 className="h2_style">{t("NEWPASSWORD.CHANGEPASS")}</h2>
                        <h5 className="h2_style fst-italic color-light-blue">{t("NEWPASSWORD.HACKERSTAY")}</h5>
                      </>
                      : <>

                        <h2 className="h2_style text-center">{t("NEWPASSWORD.create_new_pass")}</h2>
                        <h5 className="h5_style fst-italic text-center"><Trans>{t("NEWPASSWORD.create_new_pass_tag")}</Trans></h5>
                      </>
                  }

                  {
                    localStorage.getItem('flowName') === 'login' ?
                      <>
                        <h5 className="h5_style martop30">{t("NEWPASSWORD.CHECKEMAIL")}</h5>
                      </>
                      : ""
                  }
                  <div className={`ft-inner otpauthentication ${styles.ft_inner_width}`}>
                    {ResetPassJson.map((item, i) => (
                      <>
                        <div className="input-container form-group mb-3">
                        <label>{t(`${item.label}`)}</label>
                          <input
                            type={showPassword[item.name] ? "text" : "password"}
                            className={
                              item?.isRequired && formError[item?.name]
                                ? `input form-control email-input-${flowType} is-invalid`
                                : `input form-control email-input-${flowType}`
                            }
                            id={item?.name}
                            name={item?.name}
                            placeholder=" "
                            defaultValue={formData[item?.name]}
                            onChange={onInputChangeHandler}
                            onBlur={onTouchHandler}
                            maxLength={item?.maxLength}
                          />
                         <div className={`${styles.form_image} form_imageglobal imageglobal-${flowType}`} onClick={() => toggleShowPassword(item.name)}>
                            {
                              showPassword[item.name] ? (
                                <img alt="Hide password" src={eyeiconunfold} />
                              ) : (
                                <img alt="Show password" src={eyeIcon} />
                              )
                            }
                          </div>
                          
                          <span className="h6 text-danger">
                            {item.isRequired &&
                              formError[item.name] &&
                              (formError[item.name] === "req"
                                ? t(item.error)
                                : (formError[item.name] === "regx") ? t(item.type_error) : "Password did not match")}
                          </span>
                        </div>

                      </>
                    ))}
                    
                    <div className="mt-3 form-check">
                          <input type="checkbox" className="form-check-input" id="termscondition" onChange={e => handleChange(e)} />
                          <label className="form-check-label" for="termscondition">{t("PLANS.AGREE")} <a href="/termsCondition" target="_blank"  rel="noreferrer" >{t("PLANS.TERMS")}</a></label>
                        </div>
                        <div className="d-flex align-items-center justify-content-center">
                    <button type="submit"
                      className={(formSubmitButtonDisable || !termAndCondition) ? "mt-4 mainbutton"
                        : "mt-4 mainbutton"}
                      disabled={formSubmitButtonDisable || !termAndCondition}
                      onClick={formSubmitHandler}>{t("NEWPASSWORD.CONTINUE")}</button></div>

                  </div>
                </div>
                {
                    localStorage.getItem('flowName') === 'login' ?
                      <>
                        <div className={`passtext martop60 ${styles.ft_inner_width}`}>
                          <h4 className="italic h4_style color-light-blue text-left">{t("NEWPASSWORD.FARFROMHACKER")} </h4>
                          <h4 className="h4_style p-text martop20  text-left">{t("NEWPASSWORD.STRONGPASSWORD")}</h4>
                          <ul className="">
                            <li>{t("NEWPASSWORD.CHARACTER")}</li>
                            <li>{t("NEWPASSWORD.ONENUMBER")}</li>
                            <li>{t("NEWPASSWORD.SPECIALCHAR")}</li>
                            <li>{t("NEWPASSWORD.UPPERCHAR")}</li>
                          </ul>
                        </div>
                      </>
                      : <>

                        <div className={`passtext martop60 ${styles.ft_inner_width}`}>
                          <h4 className="italic h4_style color-light-blue text-left">Valid Password Characteristics

</h4>
                          <h4 className="h4_style p-text text-left martop20">Create a strong password having:</h4>
                          <ul className="">
                            <li>{t("NEWPASSWORD.CHARACTER")}</li>
                            <li>{t("NEWPASSWORD.ONENUMBER")}</li>
                            <li>{t("NEWPASSWORD.SPECIALCHAR")}</li>
                            <li>{t("NEWPASSWORD.UPPERCHAR")}</li>
                          </ul>
                        </div>
                      </>
                  }
              </div>          
          </div>
          <Footer />
        </div>
      </section>

      <ToastContainer />

    </>

  );
};

export default ChangePaawordJsx;
